export enum TagType {
  CustomTags = 0,
  AutoTags = 1
}
